<template>
  <div class="container">
    <router-link to="/home">首页</router-link>

    <router-link to="/about">关于我们</router-link>

    <router-link to="/login">登录</router-link>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style scoped>
.container {}
</style>
